import { IFeatureFlightClient } from './interfaces/IFeatureFlightClient';
export class IFeatureFlight {
  [key: string]: boolean;
}

/**
 * Implementation for feature flight client.
 */
export class FeatureFlightClient implements IFeatureFlightClient {
  private readonly featureList: IFeatureFlight = {};
  constructor(features: IFeatureFlight) {
    this.featureList = features;
  }

  isFeatureEnabled(feature: string): boolean {
    return this.featureList[feature] ?? false;
  }
}
